export default __webpack_public_path__ + "02189933bebe143e1b31493299c22f70.png";